<template>
<div class="card">
	<div class="grid">
		<div class="col-10">
		<h4>Building Warrant of Fitness (BWOF)</h4>
		</div>
		<div class="col-2">
			<InputSwitch v-model="showDetails" style="float:right" @change="onToggleDetails" />
		</div>
	</div>
	<div class="fluid grid" v-if="visibleDetails">
		<div class="field col-12 md:col-3">
			<label>BWOF issued by</label><br />
			<Dropdown class="flex" v-model="receivedBwofData.bwofIssuedBy" :options="bwofIssuedOptions" optionValue="value" optionLabel="label" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-3">
			<label>BWOF issued date</label><br />
			<Calendar v-model="receivedBwofData.bwofIssuedDate" dateFormat="d M yy" :showIcon="true" :showButtonBar="true" class="w-100pc" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-4">
			<label>Intended life of the building</label>
			<InputText v-model="receivedBwofData.intendedLifeOfTheBuilding" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-2">
			<label>First constructed</label>
			<InputText v-model="receivedBwofData.firstConstructed" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-12">
			<label>BWOF located</label>
			<InputText v-model="receivedBwofData.bwofLocated" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-12">
			<label>Building safety manual located</label>
			<InputText v-model="receivedBwofData.buildingSafetyManualLocated" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-6">
			<label>Building safety manual issued or updated</label><br />
			<div class="flex">
				<Calendar v-model="receivedBwofData.buildingSafetyManualIssuedOrUpdated" :showIcon="true" dateFormat="d M yy" :showButtonBar="true" class="w-100pc" :disabled="disabled" />
				<Button icon="pi pi-plus" @click="addYear(receivedBwofData.buildingSafetyManualIssuedOrUpdated)" v-tooltip.top="'Add 1 year'" :disabled="disabled" ></Button>
			</div>
		</div>
		<div class="field col-12 md:col-6">
			<label>Building consent</label>
			<InputText v-model="receivedBwofData.buildingConsent" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-4">
			<label>Compliance schedule</label>
			<InputText v-model="receivedBwofData.complianceSchedule" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-4">
			<label>Code compliance certificate</label>
			<InputText v-model="receivedBwofData.codeComplianceCertificate" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-2">
			<label v-tooltip.top="'Compliance schedule months'">Schedule months</label><br />
			<Dropdown class="flex" v-model="receivedBwofData.complianceScheduleMonths" :options="complianceScheduleMonthsOptions" optionValue="value" optionLabel="label" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-2">
			<label v-tooltip.top="'Compliance schedule on file'">Schedule on file</label><br />
			<InputSwitch v-model="receivedBwofData.complianceScheduleOnFile" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-12">
			<label>Legal description</label>
			<InputText v-model="receivedBwofData.legalDescription" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-12">
			<label>Location of building within site</label>
			<InputText v-model="receivedBwofData.locationOfBuildingWithinSite" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-12">
			<label>Building use</label>
			<InputText v-model="receivedBwofData.buildingUse" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-12">
			<label>Purpose group</label>
			<InputText v-model="receivedBwofData.purposeGroup" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-12">
			<label>Maximum number of occupants</label>
			<InputText v-model="receivedBwofData.maximumNumberOfOccupants" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-4">
			<label v-tooltip.top="'Highest Fire Hazard Category'">Highest FHC number</label>
			<InputText v-model="receivedBwofData.highestFireHazardCategoryFhcNumber" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-4">
			<label>Level / Unit no</label>
			<InputText v-model="receivedBwofData.levelUnitNo" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-2">
			<label>Issued by</label><br />
			<Dropdown class="flex" v-model="receivedBwofData.issuedBy" :options="issuedByOptions" optionValue="value" optionLabel="label" :showClear="true" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-2">
			<label>Fire report on file</label><br />
			<InputSwitch v-model="receivedBwofData.fireReportOnFile" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-3 flex-wrap">
			<label>Compass do testing or maintenance</label><br />
			<InputSwitch v-model="receivedBwofData.compassDoTestingOrMaintenance" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-3">
			<label>Owner inspections completed by</label>
			<Dropdown class="flex" v-model="receivedBwofData.ownerInspectionsCompletedBy" :options="ownerInspectionsOptions" optionValue="value" optionLabel="label" :disabled="disabled" />
		</div>
		<div class="field col-12 md:col-3">
			<label>Contact</label>
			<Dropdown class="flex" v-model="receivedBwofData.ownerContactId" :options="ownerContactsList" optionValue="contactId" optionLabel="firstName" @change="onOwnerContactChange" :disabled="disabled">
				<template #value>
					<span v-if="valueLabelForBwofContact.firstName">{{valueLabelForBwofContact.firstName}}</span>
					<span v-if="valueLabelForBwofContact.email && valueLabelForBwofContact.firstName == null">{{valueLabelForBwofContact.email}}</span>
				</template>
				<template #option="data">
					<span>{{data.option.firstName}} {{data.option.lastName}}</span><br/>
					<small class="compass-red">{{data.option.mobile}} {{data.option.email}}</small>
				</template>
			</Dropdown>
		</div>
	</div>
</div>
</template>

<script lang="ts">
	import { add } from 'date-fns';
	import { Options, Vue } from 'vue-class-component';
	import { ContactData, PropertyBwofData } from '../api-client/api-client';

	@Options({
		name: 'PropertyBwof',
		components: {
		},
		props: {
			receivedBwofData: PropertyBwofData,
			ownerContacts: Array
		}
	})
	export default class PropertyBwof extends Vue {

		receivedBwofData: PropertyBwofData = new PropertyBwofData();

		ownerContacts!: ContactData[];

		showDetails = false;

		disabled = false;

		complianceScheduleMonthsOptions = [
			{ label: '1', value: 1 },
			{ label: '2', value: 2 },
			{ label: '3', value: 3 },
			{ label: '4', value: 4 },
			{ label: '5', value: 5 },
			{ label: '6', value: 6 },
			{ label: '7', value: 7 },
			{ label: '8', value: 8 },
			{ label: '9', value: 9 },
			{ label: '10', value: 10 },
			{ label: '11', value: 11 },
			{ label: '12', value: 12 },
		];

		issuedByOptions = [
			{ label: 'None', value: null },
			{ label: 'Keith', value: 'Keith' },
			{ label: 'John', value: 'John' }
		];

		ownerInspectionsOptions = [
			{ label: 'None', value: null },
			{ label: 'Compass', value: 'Compass' },
			{ label: 'Compass Supplier', value: 'Compass Supplier' },
			{ label: 'Tenant', value: 'Tenant' },
			{ label: 'Owners Agent', value: 'Owners Agent' }
		];

		bwofIssuedOptions = [
			{ label: 'None', value: null },
			{ label: 'Compass', value: 'Compass' },
			{ label: 'Compass Supplier', value: 'Compass Supplier' },
			{ label: 'Owners Agent', value: 'Owners Agent' }
		];

		created() {
			this.showDetails = !this.emptyBwof;

			// 12 months to appear first -- order descending
			this.complianceScheduleMonthsOptions = this.complianceScheduleMonthsOptions.reverse();

			// Bwof not editable by External users, only editable by Internal
			this.disabled = !this.$store.getters.isInternalUser;
		}

		addYear(date: Date) {
			if (!this.receivedBwofData) return;

			this.receivedBwofData.buildingSafetyManualIssuedOrUpdated = add(date, { years: 1 });
		}

		onToggleDetails() {
			// Do nothing if actioned by External user
			if (!this.$store.getters.isInternalUser) {
				return;
			}

			if (this.emptyBwof && !this.receivedBwofData) {
				const propertyBwofData = new PropertyBwofData();

				if (this.ownerContacts?.length > 0) {
					const firstOwnerContact = this.ownerContacts[0];
					propertyBwofData.ownerContactId = firstOwnerContact.contactId;
					propertyBwofData.ownerContact = firstOwnerContact;
				}

				this.$emit('updateBwofData', propertyBwofData);
			}
		}

		onOwnerContactChange() {
			// Clear the owner contact
			this.receivedBwofData.ownerContact = undefined;

			if (this.receivedBwofData.ownerContactId)
				this.receivedBwofData.ownerContact = this.ownerContactsList.find(x => x.contactId == this.receivedBwofData.ownerContactId) ?? undefined;
		}

		get valueLabelForBwofContact(): ContactData {
			const bwofContact = this.ownerContactsList.find(ownerContact => ownerContact.contactId == this.receivedBwofData.ownerContactId);
			return bwofContact || new ContactData();
		}

		get ownerContactsList(): ContactData[] {
			const list = this.ownerContacts.filter(contact => contact.contactId != null);
			const emptyContact = new ContactData();
			emptyContact.firstName = "(leave blank for none)";
			list.unshift(emptyContact);
			return list;
		}

		get emptyBwof() {
			if (!this.receivedBwofData) return true;

			return (this.receivedBwofData.bwofIssuedBy == null
				&& this.receivedBwofData.bwofIssuedDate == null
				&& this.receivedBwofData.intendedLifeOfTheBuilding == null
				&& this.receivedBwofData.firstConstructed == null
				&& this.receivedBwofData.bwofLocated == null
				&& this.receivedBwofData.buildingSafetyManualLocated == null
				&& this.receivedBwofData.buildingSafetyManualIssuedOrUpdated == null
				&& this.receivedBwofData.buildingConsent == null
				&& this.receivedBwofData.complianceSchedule == null
				&& this.receivedBwofData.codeComplianceCertificate == null
				&& this.receivedBwofData.complianceScheduleMonths == null
				&& this.receivedBwofData.legalDescription == null
				&& this.receivedBwofData.locationOfBuildingWithinSite == null
				&& this.receivedBwofData.buildingUse == null
				&& this.receivedBwofData.purposeGroup == null
				&& this.receivedBwofData.maximumNumberOfOccupants == null
				&& this.receivedBwofData.highestFireHazardCategoryFhcNumber == null
				&& this.receivedBwofData.levelUnitNo == null
				&& this.receivedBwofData.issuedBy == null
				&& this.receivedBwofData.ownerInspectionsCompletedBy == null) ? true : false;
		}

		get visibleDetails() {
			if (!this.receivedBwofData) {
				this.showDetails = false;
			}

			return this.showDetails;
		}
	}
</script>

<style scoped lang="scss">
</style>